// Module
var code = `<div class="svc-tabbed-menu-item" data-bind="click: action, key2click, css: getRootCss(), attr: {id: 'tab-' + id, 'aria-controls': 'scrollableDiv-' + id, 'aria-selected': active}" role="tab">
  <!-- ko if: hasTitle -->
  <span data-bind="text: title, css: getTitleCss()"></span>
  <!-- /ko -->
  <!-- ko if: hasIcon -->
  <!-- ko component: { name: 'sv-svg-icon', params: { iconName: \$data.iconName, size: "auto", css: getIconCss(), title: \$data.tooltip || \$data.title } } -->
  <!-- /ko -->
  <!-- /ko -->
</div>`;
// Exports
export default code;